import device   from './device'
import session  from './session'
import ui       from './ui'

export default {
  device,
  session,
  ui
}